import classNames from 'classnames';
import styles from './styles.module.scss';
import { FC, HTMLAttributes, memo, ReactNode } from 'react';

export interface TMetroButtonProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string;
  onClick: VoidFunction;
  children?: ReactNode;
  icon?: string;
}

const MetroButton: FC<TMetroButtonProps> = memo(({ onClick, className, children, icon, ...rest }) => {
  return (
    <button {...rest} className={classNames(styles.metroButton, className)} onClick={onClick} type="button">
      <div className={styles.background} />
      {icon && <div className={classNames(`ui-icon-${icon}`, 'icon')} />}
      {children}
    </button>
  );
});

export default MetroButton;
